import { useFormik } from 'formik';
import React, { useCallback, useEffect, useState } from 'react';
import InputBox from 'src/components/Common/InputBox/InputBox';
import * as Yup from 'yup';
import { validation } from 'src/constants/general';
import { toaster } from 'src/utils/toaster';
import { createRole, roleUpdate } from 'src/services/roles';
import ResponsiveTextWithIconButton from 'src/components/Responsive/ResponsiveTextWithIconButton';
import rightIcon from 'src/assets/svgs/rightIcon.svg';
import { jobReport } from 'src/services/job';

const AddNewRole = ({ setIsSave, isSave, isOnSuccess, setBtnDisabled, btnDisabled, isUpdate, selectedRowData }: any) => {
    const [error, setError] = useState('');
    const [isSaveValidation, setIsSaveValidation] = useState(false);
    useEffect(() => {
        if (isSave) {
            formik.handleSubmit();
            setIsSave(false);
            setIsSaveValidation(true);
        }
    }, [isSave]);
    const getInitialValues = useCallback(() => {
        if (isUpdate && selectedRowData) {
            return {
                name: selectedRowData.name || '',
                display_name: selectedRowData.display_name || '',
                description: selectedRowData.description || null,
            };
        }

        return {
            name: '',
            display_name: '',
            description: null,
        };
    }, [isUpdate, selectedRowData]);
    const handleExportJob = async () => {
        try {
            const res = await jobReport();

            const url = window.URL.createObjectURL(new Blob([res.data]));

            const link = document.createElement('a');
            link.href = url;
            link.download = 'job-report.xlsx';
            link.click();

            window.URL.revokeObjectURL(url);
        } catch (err) {
            // error handling removed console.error to satisfy lint rules
        } finally {
        }
    };
    const onSubmit = async (values: any, helpers: any) => {
        setBtnDisabled(true);
        const payload = {
            name: `${values.name}`,
            display_name: values.display_name,
            description: values.description ?? null,
        };
        try {
            if (isUpdate) {
                const updatePayload = { ...payload, roleId: selectedRowData.id };
                const res = await roleUpdate(updatePayload);
                if (res.status === 200) {
                    isOnSuccess();
                    toaster('success', res.data.message);
                } else {
                    setError(res.data.message);
                    setBtnDisabled(false);
                }
            } else {
                const res = await createRole(payload);
                if (res.status === 200) {
                    isOnSuccess();
                    toaster('success', res.data.message);
                } else {
                    setError(res.data.message);
                    setBtnDisabled(false);
                }
            }
        } catch (err: any) {
            setError(err?.response.message);
        }
    };

    const formik = useFormik({
        initialValues: getInitialValues(),
        enableReinitialize: true,
        validationSchema: Yup.object({
            name: Yup.string().required('Please enter name'),
            display_name: Yup.string().required('Please enter display name'),
            description: Yup.string().nullable(),
        }),
        onSubmit: onSubmit,
    });

    return (
        <>
            <div className="p-8 mt-6 bg-white rounded-3xl">
                <div>
                    <div>
                        <p className="text-black text-base font-black">Adding new Role</p>
                        <p className="text-black text-sm font-medium leading-none mt-2">all the information bellow is required to add new role</p>
                    </div>
                    <form className="mt-4 gap-5">
                        <div className="flex flex-row gap-5 ">
                            <div className="flex flex-col  gap-3">
                                <div className="flex flex-col md:flex-row gap-5 max-lg:w-full">
                                    <div className="md:w-1/2 lg:w-[230px] w-full">
                                        <InputBox
                                            name={'name'}
                                            type={'text'}
                                            className="bg-gray10 border-none"
                                            onChange={(e: any) => {
                                                formik.handleChange(e);
                                                setError('');
                                                setIsSaveValidation(false);
                                            }}
                                            // onBlur={formik.handleBlur}
                                            inputId={'name'}
                                            value={formik.values.name}
                                            placeholder="Enter Name"
                                            error={formik.touched.name && isSaveValidation ? (formik.errors.name as string) : ''}
                                            maxLength={validation.name}
                                            disabled={isUpdate}
                                        />
                                    </div>
                                    <div className="md:w-1/2 lg:w-[230px] w-full">
                                        <InputBox
                                            name={'display_name'}
                                            type={'text'}
                                            className="bg-gray10 border-none"
                                            onChange={(e: any) => {
                                                formik.handleChange(e);
                                                setError('');
                                                setIsSaveValidation(false);
                                            }}
                                            // onBlur={formik.handleBlur}
                                            inputId={'display_name'}
                                            value={formik.values.display_name}
                                            placeholder="Enter Display Name"
                                            error={formik.touched.display_name && isSaveValidation ? (formik.errors.display_name as string) : ''}
                                            maxLength={validation.display_name}
                                        />
                                    </div>
                                </div>
                                <div className="w-full">
                                    <textarea
                                        value={formik.values.description ?? ''}
                                        onChange={(e: any) => {
                                            formik.handleChange(e);
                                            setError('');
                                            setIsSaveValidation(false);
                                        }}
                                        rows={4}
                                        name="description"
                                        cols={50}
                                        className="h-16 w-full px-4 py-3 bg-zinc-100 rounded-xl mt-2 text-sm font-normal scrollbar-default"
                                        placeholder="Description (Optinal)"
                                        style={{ resize: 'none', outline: 'none' }}
                                    />
                                </div>
                            </div>
                            <button type="button" className="px-4 py-2 btn-secondary btn-shadow text-sm rounded-lg font-bold e max-sm:px-1 max-sm:py-1 hidden" onClick={() => handleExportJob()}>
                                <div className="text-sm font-normal font-['Satoshi Variable'] whitespace-nowrap max-md:text-xs">EXPORT</div>
                            </button>
                        </div>

                        {error && <p className="text-red-600 mt-10 text-sm text-center">{error}</p>}
                    </form>
                </div>
            </div>
            <div className="hidden max-lg:block  pb-3 max-md:pt-5 max-lg:pt-[26px]">
                <ResponsiveTextWithIconButton title={'SAVE'} icon={rightIcon} isDisabled={btnDisabled} onclick={() => setIsSave(true)} />
            </div>
        </>
    );
};
export default AddNewRole;
